import hilden from '../assets/images/hilden.jpeg';
import PageHeader from '../components/PageHeader';
import GigList from '../components/GigList';
import { upcomingGigs, pastGigs } from '../data/gigs';
import { EMAIL } from '../data/videos';

const Live = () => {
    return (
        <>
            <PageHeader
                title='Live'
                kicker='Tour dates'
                image={hilden}
                imagePosition='center 40%'
                caption='Hilden Beer Festival, Lisburn — Photo: Gareth Gallagher'
                tint
            />
            <section className='band'>
                <div className='container'>
                    <h2 className='heading'>Upcoming</h2>
                    {upcomingGigs.length > 0
                        ? <GigList gigs={upcomingGigs} />
                        : <p className='body-lg'>New dates to be announced.</p>}
                </div>
            </section>

            <section className='band band--panel'>
                <div className='container booking'>
                    <div>
                        <p className='eyebrow'>Bookings</p>
                        <h2 className='heading'>Bring O, Kenayda to your venue</h2>
                    </div>
                    <a className='btn btn--solid' href={`mailto:${EMAIL}?subject=Booking`}>Get in touch</a>
                </div>
            </section>

            <section className='band'>
                <div className='container'>
                    <h2 className='heading'>Past shows</h2>
                    <GigList gigs={pastGigs} past />
                </div>
            </section>
        </>
    )
}
export default Live
